import React from "react"

export const overflow = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M3 8C3 8.55228 2.55228 9 2 9C1.44772 9 1 8.55228 1 8C1 7.44772 1.44772 7 2 7C2.55228 7 3 7.44772 3 8Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9C13.4477 9 13 8.55228 13 8C13 7.44772 13.4477 7 14 7Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M8 7C8.55228 7 9 7.44772 9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
)
